import { ErrorMessage } from 'formik';
import React from 'react';

const Error = ({ name }) => <ErrorMessage name={name} component='span' className='text-danger small' />;

export default Error;
